import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import axios from 'axios';
import App from './app/App';
import { attachRequestHmac } from './app/store/hmacUtils';
import 'atropos/css'

const API_BASE_URL = (process.env.REACT_APP_API_BASE_URL || '').replace(/\/+$/, '');

axios.interceptors.request.use((config) => {
  const url = config.url || '';
  if (!API_BASE_URL || !url.startsWith(API_BASE_URL)) {
    return config;
  }
  return attachRequestHmac(config);
});

const rootEl = document.getElementById('root');
const root = createRoot(rootEl);
root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);







